import AmountInput from 'ni-ui/amount-input';
import { withRegion } from '../../hoc';

const AmountInputWithRegion = withRegion(AmountInput);

export default AmountInputWithRegion;
